import { render, staticRenderFns } from "./bimSteps.vue?vue&type=template&id=55b5c390&scoped=true&"
import script from "./bimSteps.vue?vue&type=script&lang=js&"
export * from "./bimSteps.vue?vue&type=script&lang=js&"
import style0 from "./bimSteps.vue?vue&type=style&index=0&id=55b5c390&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b5c390",
  null
  
)

export default component.exports